import React from 'react';
import PropTypes from 'prop-types';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { FormattedMessageWrappedInSpan } from '../../misc';
import CustomDialog from './CustomDialog';

const CertificateOfferPreviewDialog = ({
  open,
  onRequestClose,
  certificatePreviewUrl,
}) => {
  return (
    <CustomDialog hasFixedWidth={!Boolean(certificatePreviewUrl)} open={open} onRequestClose={onRequestClose}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body certificate-body">
            <h1>
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.certificate.title"
                defaultMessage="What is certificate?"
              />
            </h1>
            {certificatePreviewUrl && (
              <div className="certificate-dialog-image">
                <img src={certificatePreviewUrl} alt="certificate preview" />
              </div>
            )}
            <div className="offerTile-item-certificate-text">
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.certificate.text"
                defaultMessage="You can create a certificate with a photo of your choice from the pictures of your Foto-Flat and with your personal data. You can download and print it."
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button className="accept" onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.acceptButton"
                defaultMessage="Ok"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

CertificateOfferPreviewDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  certificatePreviewUrl: PropTypes.string,
};

export default CertificateOfferPreviewDialog;
